import React from "react";
import { CalendarDays } from "lucide-react";
import { Button } from "../../../../ui/button";
// FilterType is now just string - no import needed

interface RunsheetEmptyStateProps {
  searchQuery: string;
  activeFilter: string;
  onClearSearch: () => void;
}

export const RunsheetEmptyState: React.FC<RunsheetEmptyStateProps> = ({
  searchQuery,
  activeFilter,
  onClearSearch
}) => {
  const getEmptyStateMessage = (): string => {
    if (searchQuery) {
      return `No bookings match "${searchQuery}"`;
    }
    if (activeFilter === "all") {
      return "No bookings for this time period";
    }
    return `No ${activeFilter.replace("-", " ")} bookings found`;
  };

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[25vh] text-center p-8">
      <CalendarDays className="h-12 w-12 text-muted-foreground mb-6 opacity-50" />
      <h2 className="text-xl font-semibold mb-3">No Bookings Found</h2>
      <p className="text-muted-foreground text-sm max-w-md mb-4">
        {getEmptyStateMessage()}
      </p>
      {searchQuery && (
        <Button variant="outline" size="sm" onClick={onClearSearch}>
          Clear Search
        </Button>
      )}
    </div>
  );
};
